import http from '@/utils/http'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getInformacao = () => {
  let config = {
    method: 'get',
    url: API_URL + 'mensagens',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

export default {
  getInformacao
}
